import React, { useCallback, useEffect, useMemo, useState } from "react";
import { X } from "lucide-react";
import { useLocation } from "react-router";
import {
  GetIsoMaterialFilterList,
  GetNcrReportFilterList,
  GetProjectReportFilterList,
  GetWeldingGasFilterList,
  GetWeldingMachineFilterList,
  GetWeldingWPQFilterList,
  GetWeldLogFilterList,
  sendIsoMetricWeldLogFilterData,
  sendMachineCertificationFilterData,
  sendMaterialFilterData,
  sendNcrReportFilterData,
  sendProjectReportFilterData,
  sendWeldingGasFilterData,
  sendWeldingOperatorFilterData,
} from "../../../redux/action/InspectionFilter/InspectionFilterAction";
import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

const FilterSidebar = ({
  isOpen,
  onClose,
  selectedIndex,
  onApplyFilters,
  setOriginalFilters,
  orginalFilters,
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const projectId =
    location.pathname.match(/\/view-project-details\/([^/]+)/)?.[1] || null;

  const { isLoad, error, filteredIsoMaterial } = useSelector(
    (state) => state.inspectionfilter
  );

  const initialFilters = {
    status: [],
    dateRange: { start: "", end: "" },
    inspectors_name: [],
    loc_id: [],
    system: [],
    size_id: [],
    description_id: [],
    heat: [],
    tag_id: [],
    surface_name: [],
    lot_number: [],
    serial_number: [],
    accept_criteria: [],
    ref_number: [],
    line: [],
    cert_id: [],
    welder_id: [],
    p_id: [],
    line_no: [],
    iso_draw_no: [],
    equipment_id: [],
    mechanical_contractor: [],
    classification: [],
    material_type:[],
  };
  const [integratedData, setIntegratedData] = useState({});
  const [filters, setFilters] = useState(initialFilters);
  const [showMoreSections, setShowMoreSections] = useState({});

  const IsoMaterialtypes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10,11];
  const WeldinGastypes = [1, 2, 3, 5, 6];
  const WeldingMachinetypes = [1, 2, 3, 5, 6];
  const WelderWPQtypes = [1, 2, 3, 4, 5, 6];
  const WeldingLogtypes = [1, 2, 3, 4, 5, 6];
  const NcrReporttypes = [1, 2, 3, 4, 5, 6];
  const ProjectReporttypes = [1, 2, 3, 4, 5, 6];

  useEffect(() => {
    const fetchData = async () => {
      switch (selectedIndex) {
        case 0:
          for (const type of IsoMaterialtypes) {
            await dispatch(GetIsoMaterialFilterList(projectId, type));
          }
          break;
        case 1:
          for (const type of WeldinGastypes) {
            await dispatch(GetWeldingGasFilterList(projectId, type));
          }
          break;

        case 2:
          for (const type of WeldingMachinetypes) {
            await dispatch(GetWeldingMachineFilterList(projectId, type));
          }
          break;
        case 3:
          for (const type of WelderWPQtypes) {
            await dispatch(GetWeldingWPQFilterList(projectId, type));
          }
          break;

        case 4:
          for (const type of WeldingLogtypes) {
            await dispatch(GetWeldLogFilterList(projectId, type));
          }
          break;
        case 5:
          for (const type of ProjectReporttypes) {
            await dispatch(GetProjectReportFilterList(projectId, type));
          }
          break;
        case 6:
          for (const type of NcrReporttypes) {
            await dispatch(GetNcrReportFilterList(projectId, type));
          }
          break;

        default:
          setIntegratedData({});
      }
    };
    fetchData();
  }, [dispatch, projectId, selectedIndex, setIntegratedData]);

  const filterOptions = useMemo(() => {
    const extractUniqueNames = (array, key) => [
      ...new Set(array?.map((item) => item[key])),
    ];

    return {
      0: {
        receiving: extractUniqueNames(
          filteredIsoMaterial.isoMaterial["1"],
          "name"
        ),
        line: extractUniqueNames(filteredIsoMaterial.isoMaterial["2"], "name"),
        descriptions: extractUniqueNames(
          filteredIsoMaterial.isoMaterial["3"],
          "name"
        ),
        sizes: extractUniqueNames(filteredIsoMaterial.isoMaterial["4"], "name"),
        heats: extractUniqueNames(filteredIsoMaterial.isoMaterial["5"], "name"),
        tagId: extractUniqueNames(filteredIsoMaterial.isoMaterial["6"], "name"),
        status: extractUniqueNames(
          filteredIsoMaterial.isoMaterial["7"],
          "name"
        ),
        inspectorNames: [
          ...new Set(filteredIsoMaterial.isoMaterial["8"]?.map((item) => item)),
        ],
        material_type: extractUniqueNames(
          filteredIsoMaterial.isoMaterial["9"],
          "name"
        ),
        surfaceNames: [
          ...new Set(
            filteredIsoMaterial.isoMaterial["10"]?.map((item) => item)
          ),
        ],
        classification: extractUniqueNames(
          filteredIsoMaterial.isoMaterial["11"],
          "name"
        ),
      },
      1: {
        acceptanceCriteria: extractUniqueNames(
          filteredIsoMaterial.weldingGas["1"],
          "name"
        ),
        locations: [
          ...new Set(filteredIsoMaterial.weldingGas["2"]?.map((item) => item)),
        ],
        numbers: extractUniqueNames(
          filteredIsoMaterial.weldingGas["3"],
          "name"
        ),
        status: extractUniqueNames(filteredIsoMaterial.weldingGas["5"], "name"),
        inspectorNames: [
          ...new Set(filteredIsoMaterial.weldingGas["6"]?.map((item) => item)),
        ],
      },
      2: {
        acceptanceCriteria: extractUniqueNames(
          filteredIsoMaterial.weldingMachine["1"],
          "name"
        ),
        locations: [
          ...new Set(
            filteredIsoMaterial.weldingMachine["2"]?.map((item) => item)
          ),
        ],
        numbers: extractUniqueNames(
          filteredIsoMaterial.weldingMachine["3"],
          "name"
        ),
        status: extractUniqueNames(
          filteredIsoMaterial.weldingMachine["5"],
          "name"
        ),
        inspectorNames: [
          ...new Set(
            filteredIsoMaterial.weldingMachine["6"]?.map((item) => item)
          ),
        ],
      },
      3: {
        acceptanceCriteria: extractUniqueNames(
          filteredIsoMaterial.weldWPQ["1"],
          "name"
        ),
        welderId: extractUniqueNames(filteredIsoMaterial.weldWPQ["2"], "name"),
        names: extractUniqueNames(filteredIsoMaterial.weldWPQ["3"], "name"),
        certId: extractUniqueNames(filteredIsoMaterial.weldWPQ["4"], "name"),
        status: extractUniqueNames(filteredIsoMaterial.weldWPQ["5"], "name"),
        inspectorNames: [
          ...new Set(filteredIsoMaterial.weldWPQ["6"]?.map((item) => item)),
        ],
      },
      4: {
        iso_draw_no: extractUniqueNames(
          filteredIsoMaterial.weldLog["1"],
          "name"
        ),
        system: extractUniqueNames(filteredIsoMaterial.weldLog["2"], "name"),
        lineNo: extractUniqueNames(filteredIsoMaterial.weldLog["3"], "name"),
        pId: extractUniqueNames(filteredIsoMaterial.weldLog["4"], "name"),
        status: extractUniqueNames(filteredIsoMaterial.weldLog["5"], "name"),
        inspectorNames: [
          ...new Set(filteredIsoMaterial.weldLog["6"]?.map((item) => item)),
        ],
      },
      5: {
        equipment_id: extractUniqueNames(
          filteredIsoMaterial.projectReport["1"],
          "name"
        ),
        locations: [
          ...new Set(
            filteredIsoMaterial.projectReport["2"]?.map((item) => item)
          ),
        ],
        system: extractUniqueNames(
          filteredIsoMaterial.projectReport["3"],
          "name"
        ),
        mechanical_contractor: extractUniqueNames(
          filteredIsoMaterial.projectReport["4"],
          "name"
        ),
        status: extractUniqueNames(
          filteredIsoMaterial.projectReport["5"],
          "name"
        ),
        inspectorNames: [
          ...new Set(
            filteredIsoMaterial.projectReport["6"]?.map((item) => item)
          ),
        ],
      },
      6: {
        equipment_id: extractUniqueNames(
          filteredIsoMaterial.ncrReport["1"],
          "name"
        ),
        locations: [
          ...new Set(filteredIsoMaterial.ncrReport["2"]?.map((item) => item)),
        ],
        system: extractUniqueNames(filteredIsoMaterial.ncrReport["3"], "name"),
        mechanical_contractor: extractUniqueNames(
          filteredIsoMaterial.ncrReport["4"],
          "name"
        ),
        status: extractUniqueNames(filteredIsoMaterial.ncrReport["5"], "name"),
        inspectorNames: [
          ...new Set(filteredIsoMaterial.ncrReport["6"]?.map((item) => item)),
        ],
      },
    };
  }, [filteredIsoMaterial]);

  useEffect(() => {
    if (filteredIsoMaterial) {
      const keyMap = {
        0: "isoMaterial",
        1: "weldingGas",
        2: "weldingMachine",
        3: "weldWPQ",
        4: "weldLog",
        5: "projectReport",
        6: "ncrReport",
      };

      const currentKey = keyMap[selectedIndex];
      if (currentKey) {
        const currentData = filteredIsoMaterial[currentKey];
        const newData = Object.keys(currentData).reduce((acc, key) => {
          acc[key] = currentData[key] || [];
          return acc;
        }, {});

        setIntegratedData(newData);
      } else {
        setIntegratedData({});
      }
    }
  }, [filteredIsoMaterial, selectedIndex]);

  useEffect(() => {
    setIntegratedData({});
  }, [selectedIndex]);

  const handleCheckboxChange = useCallback((category, value) => {
    setFilters((prev) => ({
      ...prev,
      [category]: prev[category]
        ? prev[category].includes(value)
          ? prev[category].filter((item) => item !== value)
          : [...prev[category], value]
        : [value],
    }));
  }, []);

  // const handleDateChange = useCallback((field, value) => {
  //   setFilters((prev) => ({
  //     ...prev,
  //     dateRange: {
  //       ...prev.dateRange,
  //       [field]: value,
  //     },
  //   }));
  // }, []);
  const handleDateChange = useCallback((field, value) => {
    const [year, month, day] = value.split("-");
    const backendDate = `${year}/${month}/${day}`;
    setFilters((prev) => ({
      ...prev,
      dateRange: {
        ...prev.dateRange,
        [field]: backendDate,
      },
    }));
  }, []);


const formatDateForFrontend = (date) => {
  if (!date) return ""; 
  const [year, month, day] = date.split("/");
  return `${year}-${day}-${month}`;
};

  const handleApply = async () => {
    const filterActions = [
      sendMaterialFilterData,
      sendWeldingGasFilterData,
      sendMachineCertificationFilterData,
      sendWeldingOperatorFilterData,
      sendIsoMetricWeldLogFilterData,
      sendProjectReportFilterData,
      sendNcrReportFilterData,
    ];

    try {
      await filterActions[selectedIndex]({ projectId, filters });
      onApplyFilters(filters);
      setOriginalFilters(filters);
      onClose();
    } catch (error) {
      console.error("Error applying filters: ", error);
    }
  };

  useEffect(() => {
    console.log("inside useeffect ", orginalFilters)
    setFilters(orginalFilters);
  }, [orginalFilters]);

  const handleClear = () => {
    setFilters(initialFilters);
    setOriginalFilters(initialFilters)
    onApplyFilters(initialFilters);
  };


  const handleInspectorNameChange = (event) => {
    const {
      target: { value },
    } = event;
    setFilters((prev) => ({
      ...prev,
      inspectors_name: typeof value === "string" ? value : value,
    }));
  };

  const renderFilterSection = useCallback(
    (type, options, filterKey) => {
      if (!options || options.length === 0) return null;

      //  Check if this section is expanded
      const isExpanded = showMoreSections[filterKey] || false;
      const displayedOptions = isExpanded ? options : options.slice(0, 5);
      return (
        <div>
          <h3 className="font-medium mb-2">{type}</h3>
          <div className="space-y-2">
            {/* {options.map((option) => ( */}
            {displayedOptions.map((option) => (
              <label key={option} className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={filters[filterKey]?.includes(option)}
                  onChange={() => handleCheckboxChange(filterKey, option)}
                  className="rounded border-gray-300"
                />
                <span>{option}</span>
              </label>
            ))}
          </div>
          {/* ........Toggle the visibility for this section ........ */}
          {options.length > 5 && (
            <button
              onClick={() =>
                setShowMoreSections((prev) => ({
                  ...prev,
                  [filterKey]: !prev[filterKey],
                }))
              }
              className="text-blue-600 mt-2"
            >
              {isExpanded ? "See Less" : "See More"}
            </button>
          )}
        </div>
      );
    },
    [filters, handleCheckboxChange, showMoreSections]
  );

  const renderFilterSpecificSection = (
    options,
    filterKey,
    filters,
    handleCheckboxChange,
    title
  ) => {
    if (!options) return null;

    return (
      <div>
        <h3 className="font-medium mb-2">{title}</h3>
        <div className="space-y-2">
          {options.map((item) => (
            <label key={item?._id} className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={filters[filterKey].includes(item?._id)}
                onChange={() => handleCheckboxChange(filterKey, item?._id)}
                className="rounded border-gray-300"
              />
              <span>{item?.name}</span>
            </label>
          ))}
        </div>
      </div>
    );
  };

  const renderFilterContent = useMemo(() => {
    const currentOptions = filterOptions[selectedIndex] || {};

    return (
      <>
        {currentOptions.status &&
          renderFilterSection("Status", currentOptions.status, "status")}
        <div>
          <h3 className="font-medium mb-2">Date Range</h3>
          <div className="space-y-2">
            <input
              type="date"
              // value={filters.dateRange.start}
              value={formatDateForFrontend(filters.dateRange.start)}
              onChange={(e) => handleDateChange("start", e.target.value)}
              className="w-full p-2 border rounded"
            />
            <input
              type="date"
              // value={filters.dateRange.end}
              value={formatDateForFrontend(filters.dateRange.end)}
              onChange={(e) => handleDateChange("end", e.target.value)}
              className="w-full p-2 border rounded"
            />
          </div>
        </div>
        {currentOptions.inspectorNames && (
          <div>
            <h3 className="font-medium mb-2">Inspector Name</h3>
            <FormControl fullWidth>
              <InputLabel id="inspector-name-label">
                Select Inspectors
              </InputLabel>
              <Select
                labelId="inspector-name-label"
                id="inspector-name-select"
                multiple
                value={filters.inspectors_name}
                onChange={handleInspectorNameChange}
                renderValue={(selectedIds) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                    {selectedIds.map((id) => {
                      const inspector = currentOptions.inspectorNames.find(
                        (option) => option?._id === id
                      );
                      return (
                        <Chip
                          key={id}
                          label={inspector ? inspector?.name : id}
                          sx={{ margin: 0.5 }}
                        />
                      );
                    })}
                  </Box>
                )}
                className="border rounded"
              >
                {currentOptions.inspectorNames.map((inspector) => (
                  <MenuItem key={inspector?._id} value={inspector?._id}>
                    {inspector?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        )}
        {renderFilterSpecificSection(
          currentOptions.surfaceNames,
          "surface_name",
          filters,
          handleCheckboxChange,
          "Surface Name"
        )}
        {renderFilterSpecificSection(
          currentOptions.locations,
          "loc_id",
          filters,
          handleCheckboxChange,
          "Location"
        )}
        {selectedIndex === 0 && (
          <>
            {renderFilterSection(
              "Classiification",
              currentOptions.classification,
              "classification"
            )}
            {renderFilterSection("Sizes", currentOptions.sizes, "size_id")}
            {renderFilterSection(
              "Material Type",
              currentOptions.material_type,
              "material_type"
            )}
            {renderFilterSection("Lines", currentOptions.line, "line")}
            {renderFilterSection("Tag ID", currentOptions.tagId, "tag_id")}
            {renderFilterSection(
              "Receiving",
              currentOptions.receiving,
              "receiving"
            )}
            {renderFilterSection(
              "Material Descriptions",
              currentOptions.descriptions,
              "description_id"
            )}
            {renderFilterSection("Heats", currentOptions.heats, "heat")}
          </>
        )}
        {selectedIndex === 1 &&
          renderFilterSection(
            "Lot Serial/Number",
            currentOptions.numbers,
            "lot_number"
          )}
        {selectedIndex === 2 &&
          renderFilterSection(
            "Weld Serial Number",
            currentOptions.numbers,
            "serial_number"
          )}
        {[1, 2, 3].includes(selectedIndex) &&
          renderFilterSection(
            "Acceptance Criteria",
            currentOptions.acceptanceCriteria,
            "accept_criteria"
          )}
        {selectedIndex === 3 && (
          <>
            {renderFilterSection(
              "Cert ID/type",
              currentOptions.certId,
              "cert_id"
            )}
            {renderFilterSection(
              "Welder ID",
              currentOptions.welderId,
              "welder_id"
            )}
          </>
        )}{" "}
        {(selectedIndex === 4 ||
          selectedIndex === 5 ||
          selectedIndex === 6) && (
          <>
            {renderFilterSection(
              "ISO Drawing No.",
              currentOptions.iso_draw_no,
              "iso_draw_no"
            )}
            {renderFilterSection(
              selectedIndex === 4 ? "System Category" : "System",
              currentOptions.system,
              "system"
            )}
            {renderFilterSection("P & ID", currentOptions.pId, "p_id")}
            {renderFilterSection(
              "Line Class",
              currentOptions.lineNo,
              "line_no"
            )}
          </>
        )}
        {[5, 6].includes(selectedIndex) && (
          <>
            {renderFilterSection(
              "Material/Equipment ID",
              currentOptions.equipment_id,
              "equipment_id"
            )}
            {renderFilterSection(
              "Contractor",
              currentOptions.mechanical_contractor,
              "mechanical_contractor"
            )}
          </>
        )}
      </>
    );
  }, [
    selectedIndex,
    filterOptions,
    filters,
    handleCheckboxChange,
    handleDateChange,
    handleInspectorNameChange,
    renderFilterSection,
  ]);

  return (
    <div
      className={`mt-16 fixed inset-y-0 right-0 z-50 w-[18%] bg-white shadow-lg transform ${
        isOpen ? "translate-x-0" : "translate-x-full"
      } transition-transform duration-300 ease-in-out`}
    >
      <div className="flex items-center justify-between p-4 border-b">
        <h2 className="text-lg font-semibold">Filters</h2>
        <button
          onClick={onClose}
          className="p-1 hover:bg-gray-100 rounded-full"
        >
          <X size={20} />
        </button>
      </div>

      <div className="p-4 space-y-6 overflow-y-auto h-[calc(100%-8rem)]">
        {renderFilterContent}
      </div>

      <div className="absolute bottom-0 left-0 right-0 p-4 border-t bg-white">
        <div className="flex space-x-2">
          <button
            onClick={handleClear}
            className="flex-1 px-4 py-2 border rounded hover:bg-gray-50"
          >
            Clear All
          </button>
          <button
            onClick={handleApply}
            className="flex-1 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterSidebar;
